import React from 'react';
import 'react-day-picker/dist/style.css';
import {
  DayPicker,
  DayPickerDefaultProps,
  DayPickerMultipleProps,
  DayPickerRangeProps,
  DayPickerSingleProps,
} from 'react-day-picker';
import { format } from 'date-fns';

import styles from './BaseCalendar.module.css';

type Props =
  | DayPickerDefaultProps
  | DayPickerSingleProps
  | DayPickerMultipleProps
  | DayPickerRangeProps;

const BaseCalendar: React.FC<Props> = (props) => (
  <DayPicker
    numberOfMonths={1}
    showOutsideDays={true}
    className={styles.calendar}
    formatters={{
      formatCaption: (date) => (
        <>
          <span className={'rdp-caption_label_month'}>{format(date, 'MMMM')}</span>{' '}
          <span className={'rdp-caption_label_year'}>{format(date, 'yyyy')}</span>
        </>
      ),
    }}
    {...props}
  />
);
export default BaseCalendar;
